import React from "react";
import PropTypes from "prop-types";
import { formatPrice } from "~/assets/js/Format";
import ClimateDetails from "~/assets/js/components/ClimateDetails";

const ConditionallyRenderAnchorTag = ({ isAvailable, children, url }) =>
    isAvailable ? <a href={url}>{children}</a> : children;

const OrderItem = ({ orderItem, isAvailable = true }) => {
    // Item data
    const ingredients = orderItem.add ? orderItem.add : [];
    const climateDetails = {
        calculated_energy: orderItem.calculated_energy || 0,
        water: orderItem.water || "0",
        co2: orderItem.co2 || "0",
    };

    const hasIngredients = !!ingredients && ingredients.length > 0;

    const renderIngredient = (ingredient) =>
        `${ingredient.quantity * orderItem.quantity} x ${ingredient.name}`;

    return (
        <div className="order-item-card">
            <ConditionallyRenderAnchorTag
                {...{ isAvailable, url: orderItem.url }}
            >
                <div className="order-item-card__image-container">
                    {orderItem.thumbnail_url && (
                        <img
                            className="order-item-card__image"
                            src={orderItem.thumbnail_url}
                            alt="product image"
                        />
                    )}
                </div>
                <div className="order-item-card__data-container">
                    <span className="order-item-card__heading">
                        {`${orderItem.quantity}x `}
                        {orderItem.name}
                    </span>
                    <span className="order-item-card__price">
                        {formatPrice(orderItem.value_gross)}
                    </span>

                    <ClimateDetails
                        climateDetails={climateDetails}
                        itemQuantity={orderItem.quantity}
                    />

                    <div className="order-item-card__additions">
                        {hasIngredients &&
                            ingredients.map((ingredient) => {
                                return (
                                    <p
                                        key={ingredient.name}
                                        className="order-item-card__additions__entry"
                                    >
                                        {renderIngredient(ingredient)}
                                    </p>
                                );
                            })}
                    </div>
                </div>
            </ConditionallyRenderAnchorTag>
        </div>
    );
};

OrderItem.propTypes = {
    orderItem: PropTypes.object.isRequired,
    isAvailable: PropTypes.bool,
};

ConditionallyRenderAnchorTag.propTypes = {
    isAvailable: PropTypes.bool.isRequired,
    url: PropTypes.string.isRequired,
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]).isRequired,
};

export default OrderItem;
